import { SCREEN_W } from "../shared/screen";
import { outlinedText } from "./hud";

export interface PauseView {
  readonly items: readonly { readonly label: string; readonly value?: number }[];
  readonly selected: number;
}

/** Меню паузы поверх боя в полном разрешении: пункты и ползунки 0–100 %. */
export function drawPauseMenu(context: CanvasRenderingContext2D, view: PauseView): void {
  context.fillStyle = "rgba(5, 4, 8, 0.82)";
  context.fillRect(360, 210, SCREEN_W - 720, 660);
  outlinedText(context, "ПАУЗА", SCREEN_W / 2, 246, 96, "#ffe2b8");
  view.items.forEach((item, index) => {
    const y = 390 + index * 90;
    const active = index === view.selected;
    outlinedText(context, item.label, 450, y, 44, active ? "#ffd24a" : "#e8e2f0", "left", active ? "bold" : "normal");
    if (item.value !== undefined) {
      context.fillStyle = "#2a1a20";
      context.fillRect(990, y + 14, 450, 24);
      context.fillStyle = active ? "#ffd24a" : "#b8862a";
      context.fillRect(990, y + 14, Math.round(450 * (item.value / 100)), 24);
      outlinedText(context, `${item.value} %`, 1476, y, 40, "#e8e2f0", "left", "normal");
    }
  });
  outlinedText(
    context,
    "↑↓ выбрать · ←→ изменить · ✕ или Enter — продолжить",
    SCREEN_W / 2,
    780,
    32,
    "#b8b0c8",
    "center",
    "normal",
  );
}
